export const onBeforeEnterEndTrigger = (element: Element) => {
  if (!(element instanceof HTMLElement)) {
    return;
  }
  element.style.opacity = '0';
};

export const onEnterEndTrigger = (element: Element, done: () => void) => {
  if (!(element instanceof HTMLElement)) {
    done();
    return;
  }
  const naturalWidth = element.offsetWidth;
  element.style.overflow = 'hidden';
  element.animate([{ width: '0px' }, { width: `${naturalWidth}px` }], {
    duration: 180,
    easing: 'ease-out',
    fill: 'backwards',
  });
  void element
    .animate([{ opacity: '0' }, { opacity: '1' }], {
      duration: 120,
      delay: 90,
      easing: 'ease-out',
      fill: 'backwards',
    })
    .finished.then(() => {
      element.style.overflow = '';
      element.style.opacity = '';
      done();
    });
};

export const onLeaveEndTrigger = (element: Element, done: () => void) => {
  if (!(element instanceof HTMLElement)) {
    done();
    return;
  }
  const width = element.offsetWidth;
  element.style.overflow = 'hidden';
  // Opacity disappears first, then width collapses once element is invisible
  element.animate([{ opacity: '1' }, { opacity: '0' }], {
    duration: 120,
    easing: 'ease-in',
  });
  void element
    .animate([{ width: `${width}px` }, { width: '0px' }], {
      duration: 180,
      delay: 90,
      easing: 'ease-out',
    })
    .finished.then(done);
};
